<template>
  <img
    :src="src"
    :loading="eager ? 'eager' : 'lazy'"
    :class="{ cover, icon, edgy }"
  />
</template>

<script setup lang="ts">
const props = defineProps<{
  src: string;
  eager?: boolean;
  cover?: boolean;
  icon?: boolean;
  preload?: boolean;
  edgy?: boolean;
}>();

if (props.preload) {
  useHead({
    link: [
      {
        rel: 'preload',
        href: props.src,
        as: 'image',
      }
    ]
  });
}
</script>

<style scoped>
img {
  max-width: 100%;
  border-radius: var(--border-r-sm);
}
img.edgy {
  border-radius: 0;
}
.cover {
  width: 100%;
}
</style>